<template>
  <div class="impactSection-body">
    <ImpactCard
      :imageSrc="imageOne"
      title="Fashion"
      text="The fashion industry is notorious for its waste, with unsold garments often being incinerated or sent to landfills. At Wecobi, we’re changing this by giving these garments a second life. Through our platform, brands can offload excess inventory, reducing textile waste, conserving water, and cutting down on carbon emissions. This not only saves resources but also aligns with growing consumer demand for sustainable fashion."
    />
    <ImpactCard
      :imageSrc="imageTwo"
      title="Cosmetics"
      text="The cosmetics industry faces its own set of challenges, particularly in the disposal of unsold beauty products. These products often contain chemicals that, if not disposed of properly, can be harmful to the environment. Wecobi helps prevent the disposal of these products by providing an avenue for their redistribution, reducing chemical waste and conserving the resources used in their production. This approach helps brands maintain their environmental integrity while appealing to eco-conscious consumers."
    />
    <ImpactCard
      :imageSrc="imageThree"
      title="Consumer Electronics"
      text="The cosmetics industry faces its own set of challenges, particularly in the disposal of unsold beauty products. These products often contain chemicals that, if not disposed of properly, can be harmful to the environment. Wecobi helps prevent the disposal of these products by providing an avenue for their redistribution, reducing chemical waste and conserving the resources used in their production. This approach helps brands maintain their environmental integrity while appealing to eco-conscious consumers."
    />
    <ImpactCard
      :imageSrc="imageFour"
      title="Home Goods"
      text="The disposal of surplus household items contributes significantly to landfill waste. At Wecobi, we’re turning this surplus into sustainable opportunities. By facilitating the redistribution of these items, we promote responsible consumption, reduce waste, and help consumers access quality products at lower prices. This approach not only benefits the environment but also fosters a culture of sustainability among consumers."
    />
  </div>
</template>

<script>
import ImpactCard from "./ReusableComponents/ImpactCard.vue";
import Fashion from "../../../assets/sustainability/ImpactSection/Fashion.png";
import Cosmetics from "../../../assets/sustainability/ImpactSection/Cosmetics.png";
import ConsumerElectronics from "../../../assets/sustainability/ImpactSection/ConsumerElectronics.png";
import HomeGoods from "../../../assets/sustainability/ImpactSection/HomeGoods.png";

export default {
  name: "ImpactSection",
  components: {
    ImpactCard,
  },
  data: function () {
    return {
      imageOne: Fashion,
      imageTwo: Cosmetics,
      imageThree: ConsumerElectronics,
      imageFour: HomeGoods,
    };
  },
};
</script>

<style scoped>
.impactSection-body {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}
@media (max-width: 778px) {
  .impactSection-body {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 16px;
  }
}
</style>
